// for supporting IE
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';

import './localization/i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { store, persistor } from './store';
import ApiManager from './network/api_manager';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      suspense: false,
    },
  },
});

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <ApiManager>
        <QueryClientProvider client={queryClient}>
          <Suspense fallback={null}>
            <App />
          </Suspense>
          <ReactQueryDevtools />
        </QueryClientProvider>
      </ApiManager>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);

reportWebVitals();
